import { Component, EventEmitter, Input, OnChanges, OnDestroy, OnInit, Output, ViewChild } from '@angular/core';
import { Platform } from '@ionic/angular';
import _dayjs from 'dayjs';
import { DaterangepickerDirective } from 'ngx-daterangepicker-material';
import { LoggerService } from '../../services/logger/logger.service';
import { BASE_CONFIG } from '../../util/base-settings';
import { DATE_TIME_FORMAT, FILE_NAME } from '../../util/constants';
import { DateFunctions } from 'src/app/util/date-functions';
import dayjs from 'dayjs/esm'
  

@Component({
  selector: 'ngx-date-picker',
  templateUrl: './date-picker.component.html',
  styleUrls: ['./date-picker.component.scss']
})
export class DatePickerComponent implements OnInit, OnChanges , OnDestroy {
  selected: {start: _dayjs.Dayjs, end: _dayjs.Dayjs};
  minimumDate: dayjs.Dayjs;
  maximumDate: dayjs.Dayjs;
  ranges: any = null

  isWeb : boolean = BASE_CONFIG.IS_WEB ;
  @Input() singleDatePicker:boolean=false;
  @Input() selectedVal:any=null;
  @Input() placeholder:string;
  @Input() format:string = DATE_TIME_FORMAT.COMMON_DATE_FORMAT;
  @Input() control: any = null;
  @Input() isFormSubmitted:boolean=false;
  @Input() isAppointmentTable:boolean=false;
  @Input() dropPosition : string = "down";
  @Input() isDisable : boolean = false;
  @Input() isNeedCancelButton : boolean = false;
  @Input() minDate: string = "";
  @Input() maxDate: string = "";
  @Output() selDateVal = new EventEmitter<any>();
  @Output() onClickDatePicker = new EventEmitter<any>();
  @ViewChild(DaterangepickerDirective, { static: false }) pickerDirective: DaterangepickerDirective;

  @ViewChild('datePickerRef') datePickerRef;

  constructor( private logger: LoggerService,
    private platform: Platform,
    private dateFunctions: DateFunctions,
    // private util:UtilFunctions,
  ) {
    this.platform.backButton.subscribeWithPriority(10, () =>
    {
      this.pickerDirective.hide();
    });
  }

  ngOnDestroy(): void {
    document.body.classList.remove('show_datepicker');
  }

  ngOnInit(): void {
    try{
    if(BASE_CONFIG.IS_DEBUG) console.log("ngOnInit-"+FILE_NAME.DATE_PICKER_COMPONENT);
    if(!this.singleDatePicker){
    this.ranges = this.toGetRangeValue();
    }
    if(this.selectedVal!=null){
      // this.selected.startDate = _dayjs(this.selectedVal)
      // this.selected.endDate = _dayjs(this.selectedVal)
      // this.selected = this.selectedVal;

      this.selected.start =this.selectedVal.start?this.selectedVal.start.$d?this.selectedVal.start.$d=='Invalid Date'?_dayjs(new Date()):_dayjs(this.selectedVal.start.$d): _dayjs(this.selectedVal.start): _dayjs(this.selectedVal);
      this.selected.end = this.selectedVal.end?this.selectedVal.end.$d?this.selectedVal.end.$d=='Invalid Date'?_dayjs(new Date()):_dayjs(this.selectedVal.end.$d): _dayjs(this.selectedVal.end): _dayjs(this.selectedVal);
      // this.selDateVal.emit(this.selected)
      
    }
    if (this.minDate && this.maxDate) {
      this.minimumDate = dayjs(this.minDate);
      this.maximumDate = dayjs(this.maxDate);
    }
    
  }
  catch(err)
  {
    let logRequest = this.logger.buildRequest(
      FILE_NAME.DATE_PICKER_COMPONENT,
    "error in ngOnInit",
    err.toString(),
     "ngOnInit",
      );
     this.logger.log(logRequest);
  }
  }

  ngOnChanges(changes): void {
   
    if(changes && changes.selectedVal  ){
      this.selected = changes.selectedVal.currentValue ;
      if(this.selectedVal!=null){
        // this.selected.startDate = _dayjs(this.selectedVal)
        // this.selected.endDate = _dayjs(this.selectedVal)
        // this.selected = this.selectedVal;
        this.selected.start =this.selectedVal.start? _dayjs(this.selectedVal.start): _dayjs(this.selectedVal)
        this.selected.end = this.selectedVal.end?_dayjs(this.selectedVal.end):_dayjs(this.selectedVal)
        // this.selDateVal.emit(this.selected)


      }
    }
  }
  onCancel() {
      try {
        if(BASE_CONFIG.IS_DEBUG) console.log("onCancel");
       this.pickerDirective.hide();
      } catch (err) {
              let logRequest =  this.logger.buildRequest(
                FILE_NAME.DATE_PICKER_COMPONENT,
                "error in onCancel",
                err.toString(),
                "onCancel",
              );
              this.logger.log(logRequest)
            }
      }
  onClickInput(){
    try{
      if(BASE_CONFIG.IS_DEBUG) console.log("onClickInput");
      if(!this.isWeb){
        let daterangepicker= document.querySelector('ngx-daterangepicker-material .md-drppicker');
        let cancelEl=document.getElementById('datepick-cancel');
        if (cancelEl) {
          daterangepicker.appendChild(cancelEl);
        }
        document.body.classList.add('show_datepicker');
        }
      this.onClickDatePicker.emit();
 setTimeout(()=>{
  if(!this.isWeb){
    let daterangepicker= document.querySelector('ngx-daterangepicker-material .md-drppicker');
   let cancelEl=document.getElementById('datepick-cancel');
   if (cancelEl) {
    daterangepicker.appendChild(cancelEl);
   }
    }
 },50)
     
  }
  catch(err)
  {
    let logRequest = this.logger.buildRequest(
      FILE_NAME.DATE_PICKER_COMPONENT,
    "error in onClickInput",
    err.toString(),
     "onClickInput",
      );
     this.logger.log(logRequest);
  }
  }
  datesUpdated(event):void {
    try{
      if(BASE_CONFIG.IS_DEBUG) console.log("datesUpdated");

      document.body.classList.remove('show_datepicker');
      if(event && event.start!=null && event.end!=null) {
        const dateObj = {start: new Date(event.start.$y, event.start.$M, event.start.$D), end: new Date(event.end.$y, event.end.$M, event.end.$D)}
        this.selected.start = event.start.$d
        this.selected.end = event.end.$d
        this.selDateVal.emit(dateObj)
      }
    }
    catch(err)
    {
      let logRequest = this.logger.buildRequest(
        FILE_NAME.DATE_PICKER_COMPONENT,
      "error in datesUpdated",
      err.toString(),
       "datesUpdated",
        );
       this.logger.log(logRequest);
    }
  }
  openDatepicker(event):void {
    try{
      if(BASE_CONFIG.IS_DEBUG) console.log("openDatepicker");
    this.pickerDirective.open(event);
    }
    catch(err)
    {
      let logRequest = this.logger.buildRequest(
        FILE_NAME.DATE_PICKER_COMPONENT,
      "error in openDatepicker",
      err.toString(),
       "openDatepicker",
        );
       this.logger.log(logRequest);
    }
  }

  toGetRangeValue():any{
    let retValue:any
  try{
    if(BASE_CONFIG.IS_DEBUG) console.log("toGetRangeValue");
  retValue={
    'Today': [_dayjs().format(), _dayjs().format()],
    'Yesterday': [_dayjs().subtract(1, 'days').format(), _dayjs().subtract(1, 'days').format()],
    'Last 7 Days': [_dayjs().subtract(7, 'days').format(), _dayjs().subtract(1, 'days').format()],
    'Last 30 Days': [_dayjs().subtract(30, 'days').format(), _dayjs().subtract(1, 'days').format()],
    'This Month': [_dayjs().startOf('month').format(), _dayjs().endOf('month').format()],
    'Last Month': [_dayjs().subtract(1, 'month').startOf('month').format(), _dayjs().subtract(1, 'month').endOf('month').format()],
    'This Year': [_dayjs().startOf('year').format(), _dayjs().endOf('year').format()],
    'Last Year': [_dayjs().subtract(1,'year').startOf('year').format(), _dayjs().subtract(1, 'year').endOf('year').format()],
  }
  }
   catch(err)
  {
    let logRequest = this.logger.buildRequest(
      FILE_NAME.DATE_PICKER_COMPONENT,
    "error in toGetRangeValue",
    err.toString(),
     "toGetRangeValue",
      );
     this.logger.log(logRequest);
  }
  return retValue
   }

   closePicker()
   {
    console.log('closePicker');
    
    document.body.classList.remove('show_datepicker');
    this.pickerDirective.hide();
   }

}
